import { Directive, Input, OnInit, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppContextService, appId } from './app-context.service';

type componentState = 'initial' | 'contentRendered' | 'elseTemplateRendered' | 'cleared';

@Directive({
  selector: '[kgrIfAppId]',
  standalone: true,
})
export class IfAppIdDirective implements OnInit {
  private state = signal<componentState>('initial');

  constructor(
    private appContextService: AppContextService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input({ required: true }) kgrIfAppId: appId;
  @Input() kgrIfAppIdElse?: TemplateRef<unknown>;

  ngOnInit() {
    if (this.appContextService.isAppId(this.kgrIfAppId)) {
      if (this.state() !== 'contentRendered') {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.state.set('contentRendered');
      }
    } else if (this.kgrIfAppIdElse) {
      if (this.state() !== 'elseTemplateRendered') {
        this.viewContainer.createEmbeddedView(this.kgrIfAppIdElse);
        this.state.set('elseTemplateRendered');
      }
    } else {
      if (this.state() !== 'cleared') {
        this.viewContainer.clear();
        this.state.set('cleared');
      }
    }
  }
}
